import React from 'react';
import ProductModifierGroupSimple from "./Simple/ProductModifierGroupSimple";
import ProductModifierGroupAdvanced from "./Advanced/ProductModifierGroupAdvanced";
import MenuEditItemStateHelper from "../../../../../../services/Menu/services/State/MenuEditItemStateHelper";
import MenuEditItemViewHelper from "../../../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";
import ProductModifierGroupSingleSelect from "./SingleSelect/ProductModifierGroupSingleSelect";

interface Props {
    productModifierGroups: Record<string, any>[];
    updateProductState: (productState: Record<string, any>) => void;
    productState: Record<string, any>;
    productView: Record<string, any>;
    isProductAvailable: boolean;
    isProductASet: boolean;
}

const ProductModifierGroups = ({
                                   updateProductState,
                                   productState,
                                   productView,
                                   isProductAvailable,
                                   isProductASet
                               }: Props) => {
    const rawModifierGroups: Record<string, any>[] = productView.configurable_modifier_groups;
    const modifierGroups = rawModifierGroups.map(MenuEditItemViewHelper.parseModifierGroupForIncludedQuantity);

    if (modifierGroups.length === 0) return <></>;

    return (
        <div className="d-flex flex-column gap-3">
            {modifierGroups.map(productModifierGroup => {
                const isAdvanced = MenuEditItemStateHelper.isModifierGroupAdvanced(productModifierGroup);
                const isSingleSelect = (productModifierGroup.min_permitted === 1 && productModifierGroup.max_permitted === 1)

                if (isSingleSelect && !isProductASet) {
                    return (
                        <ProductModifierGroupSingleSelect key={productModifierGroup.id}
                                                          modifierGroup={productModifierGroup}
                                                          updateProductState={updateProductState}
                                                          isProductAvailable={isProductAvailable}
                                                          productState={productState}/>
                    )
                }

                if (isAdvanced) {
                    return <ProductModifierGroupAdvanced key={productModifierGroup.id}
                                                         modifierGroup={productModifierGroup}
                                                         updateProductState={updateProductState}
                                                         isProductAvailable={isProductAvailable}
                                                         productState={productState}/>
                }

                return (
                    <ProductModifierGroupSimple key={productModifierGroup.id} modifierGroup={productModifierGroup}
                                                updateProductState={updateProductState} productState={productState}
                                                isProductAvailable={isProductAvailable} isProductASet={isProductASet}
                    />
                )
            })}
        </div>
    )
}

export default ProductModifierGroups;